import { mergeAttributes, Node } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'

import { EVENT_DATA_ID, EVENT_DATA_TYPE } from './constants.js'
import { EventNodeContent } from './EventNodeContent.js'

export interface EventOptions {
  HTMLAttributes: Record<string, unknown>
}

interface EventAttr {
  id?: string
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    event: {
      insertEvent: (options: EventAttr) => ReturnType
    }
  }
}

export const EventNode = Node.create<EventOptions>({
  name: 'event',
  inline: false,
  group: 'block',
  draggable: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },
  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: element => {
          return element.getAttribute(EVENT_DATA_ID)
        },
        renderHTML: attrs => ({
          [EVENT_DATA_ID]: attrs.id,
        }),
      },
      updatedAt: {
        default: null,
        rendered: false,
      },
    }
  },
  parseHTML() {
    return [
      {
        tag: 'div',
        getAttrs: element => {
          return element.getAttribute('data-type') === EVENT_DATA_TYPE && null
        },
      },
    ]
  },
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, { 'data-type': EVENT_DATA_TYPE }),
    ]
  },
  addNodeView() {
    return ReactNodeViewRenderer(EventNodeContent, {
      attrs: ({ node }) => ({
        [EVENT_DATA_ID]: node.attrs.id,
      }),
    })
  },
  addCommands() {
    return {
      insertEvent:
        attrs =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs,
          })
        },
    }
  },
})
